"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningType = void 0;
exports.instanceOfWarningType = instanceOfWarningType;
exports.WarningTypeFromJSON = WarningTypeFromJSON;
exports.WarningTypeFromJSONTyped = WarningTypeFromJSONTyped;
exports.WarningTypeToJSON = WarningTypeToJSON;
exports.WarningTypeToJSONTyped = WarningTypeToJSONTyped;
/**
 *
 * @export
 */
exports.WarningType = {
    AdditionalSpecialtyCertificationExpired: 'AdditionalSpecialtyCertificationExpired',
    CertificationsNotVerified: 'CertificationsNotVerified',
    CertificationsExpiredInsideGracePeriod: 'CertificationsExpiredInsideGracePeriod',
    ConflictsFound: 'ConflictsFound',
    LicensesExpiredInsideGracePeriod: 'LicensesExpiredInsideGracePeriod',
    StateLicenseExpiredInsideGracePeriod: 'StateLicenseExpiredInsideGracePeriod',
    VaccinationsExpiredInsideGracePeriod: 'VaccinationsExpiredInsideGracePeriod',
    RegulatoryAssessmentsExpiredInsideGracePeriod: 'RegulatoryAssessmentsExpiredInsideGracePeriod',
    TuberculosisExpireBeforeMaxDate: 'TuberculosisExpireBeforeMaxDate',
    I9FormIncomplete: 'I9FormIncomplete',
    SupplementalBackgroundChecksPending: 'SupplementalBackgroundChecksPending'
};
function instanceOfWarningType(value) {
    for (const key in exports.WarningType) {
        if (Object.prototype.hasOwnProperty.call(exports.WarningType, key)) {
            if (exports.WarningType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function WarningTypeFromJSON(json) {
    return WarningTypeFromJSONTyped(json, false);
}
function WarningTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function WarningTypeToJSON(value) {
    return value;
}
function WarningTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=WarningType.js.map